import React from 'react'
import './dpu-alumni.css'
import Common_title from '../../common_components/common-title/Common_title'

const Dpu_alumni = () => {
    return (
        <>
            <section className='Dpu_alumni_sec'>
                <div className='container'>
                    <Common_title className="text-center" title="DPU Alumni" />
                    <div className='row'>
                        <div className='col-sm-6 mb-3'>
                            <img className='banner' src={process.env.PUBLIC_URL + '/assets/images/home/dpu-alumni/Image 4.png'} />
                        </div>
                        <div className='col-sm-6 mb-3'>
                            <img className='banner' src={process.env.PUBLIC_URL + '/assets/images/home/dpu-alumni/Image 6.png'} />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Dpu_alumni